import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OccupationalDoctorService } from '@/infra/services/occupational-doctor';

interface UpdateOccupationalDoctorParams {
	id: string;
	name: string;
	company_id: string;
	organization_id: string;
}

const Service = OccupationalDoctorService.getInstance();

export const useUpdateOccupationalDoctor = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (params: UpdateOccupationalDoctorParams) => Service.update(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_OCCUPATIONAL_DOCTOR]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_LIST_OCCUPATIONAL_DOCTOR]);
			message.success(I18n.get('Occupational doctor updated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error on update occupational doctor'));
		}
	});
};
